/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import {
  BeneficiaireRapatriement,
  DevisRapatriementParam,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {
  IAssured,
  IAssuredRapatriementDTO,
  IEAssured,
  RapatriementModifDTO,
} from '../../data/types/interface/Assurance/AssuranceRapatriement/souscription';
import {RapatriementBDL} from '../bdl/rapatriement';

// TODO: verify data to send
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface souscriptionAssureBodyDTO
  extends Omit<IEAssured, 'capture_file_base64'> {}

export interface ISaveDevis {
  // agence: string;
  dateEffect: Date;
  beneficiaires: IAssured[];
}
export interface IModificationContrat {
  policyId: string;
  message: string;
  policyNumber: string;
  dateDebut: string;
  assure: Array<{
    id: string;
    nom: string;
    prenom: string;
    email: string;
    phoneNumber: string;
    passeportNumber: string;
    passeportFile: string;
  }>;
}

export const RapatriementServices = () => {
  const {
    saveDevis,
    listDevis,
    removeDevis,
    souscrireContrat,
    detailContrat,
    getContratBySimulationId,
    getStatusPayment,
    postDevis,
    redoDevis,
    uploadCarteIdentitePhoto,
    renewContrat,
    getContratBypolicyNumber,
    getTemporaryAttestationToken,
    createContrat,
    getTemporaryFraisFuneraireRapatriementToken,
  } = RapatriementBDL();

  return {
    postDevis: async (data: DevisRapatriementParam[]) => {
      return await postDevis(data);
    },
    redoDevis: async (data: DevisRapatriementParam[], dateEffet: Date) => {
      return await redoDevis(data, dateEffet);
    },
    saveDevis: async (data: ISaveDevis) => {
      try {
        for (const assure of data.beneficiaires) {
          if (assure.newImage && typeof assure.capture_file != 'string') {
            const uploadedFile = await uploadCarteIdentitePhoto(
              assure?.capture_file[0] as File,
            );

            if (uploadedFile.data) {
              assure.capture_file = uploadedFile.data.data.newFileName;
            } else {
              throw new Error(
                uploadedFile.message ||
                  `Erreur lors de l'upload de la photo de ${assure.nom} ${assure.prenom}`,
              );
            }
          } else {
            assure.capture_file = assure.lastCaptureFile;
          }
        }
        return await saveDevis(data);
      } catch (error) {
        throw error;
      }
    },
    removeDevis: async (id: string) => {
      return await removeDevis(id);
    },
    souscrireContrat: async (data: ISaveDevis) => {
      console.log('data souscrireContrat', data);
      try {
        for (const assure of data.beneficiaires) {
          if (
            assure.newImage &&
            assure.capture_file &&
            typeof assure.capture_file != 'string'
          ) {
            const uploadedFile = await uploadCarteIdentitePhoto(
              assure?.capture_file[0] as File,
            );

            if (uploadedFile.data) {
              assure.capture_file = uploadedFile.data.data.newFileName;
            } else {
              throw new Error(`Erreur lors de l'upload`);
            }
          } else {
            assure.capture_file = assure.lastCaptureFile;
          }
        }
        return await souscrireContrat(data);
      } catch (error) {
        throw error;
      }
    },
    listDevis: async () => {
      return await listDevis();
    },
    detailContrat: async (numPolice: string) => {
      return await detailContrat(numPolice);
    },
    getContratBySimulationId: async (quoteCode: string) => {
      return await getContratBySimulationId(quoteCode);
    },
    getContratByPolicyNumber: async (policyNumber: string) => {
      return await getContratBypolicyNumber(policyNumber);
    },
    getStatusPayment: async () => {
      return await getStatusPayment();
    },
    getTemporaryFraisFuneraireRapatriementToken: async (
      policyNumber: string,
      beneficiaire: BeneficiaireRapatriement,
    ) => {
      return await getTemporaryFraisFuneraireRapatriementToken(
        policyNumber,
        beneficiaire,
      );
    },
    getTemporaryAttestationToken: async (
      policyNumber: string,
      dateEffet: string,
      dateFin: string,
      benef: BeneficiaireRapatriement,
    ) => {
      return await getTemporaryAttestationToken(
        policyNumber,
        benef,
        dateEffet,
        dateFin,
      );
    },
    renewContrat: async (
      contrat: RapatriementModifDTO,
      transactionId: string,
    ) => {
      console.log('application =>', transactionId, contrat);

      const previousBenefId: string[] = [];
      const newBeneficiaires: IAssuredRapatriementDTO[] = [];
      try {
        for (const benef of contrat.assure) {
          if (benef.isNew) {
            const uploadedFile = await uploadCarteIdentitePhoto(
              benef?.capture_file[0] as File,
            );

            if (uploadedFile.data) {
              benef.capture_file = uploadedFile.data.data.newFileName;
            } else {
              throw new Error(`Erreur lors de l'upload`);
            }
            const {
              newImage,
              lastCaptureFile,
              id,
              isEditable,
              dateNaissance,
              isNew,
              ...rest
            } = benef;
            newBeneficiaires.push({
              ...rest,
              dateNaissance: dayjs(benef.dateNaissance).format('YYYY-MM-DD'),
            });
          } else {
            previousBenefId.push(benef.id);
          }
        }
        return await renewContrat({
          contratId: contrat.contratId,
          transactionId,
          beneficiaireIds: previousBenefId,
          nBeneficiaires: newBeneficiaires,
        });
      } catch (error) {
        throw error;
      }
    },
    createContrat: async (simulationId: string) => {
      return await createContrat(simulationId);
    },
  };
};
